import React, { CSSProperties } from 'react';

interface ScaleProps {
  fill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Scale: React.FC<ScaleProps> = ({ fill = 'currentColor', width = '30px', height = '30px', style }) => {
  return (
    <svg height={height} width={width} viewBox="250 250 560 560" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={30}>
        <path d="M342.5 874h375" />
        <path d="M530 874V186" />
        <path d="M218 375s186-63 311.5-63S842 375 842 375" />
        <path d="M363.5 374.5l-77.44 258.84c-8 26.75 12.03 53.66 39.96 53.66H401c27.92 0 47.96-26.91 39.96-53.66L363.52 374.5z" />
        <path d="M696.5 374.5l-77.44 258.84c-8 26.75 12.03 53.66 39.96 53.66H734c27.92 0 47.96-26.91 39.96-53.66L696.52 374.5z" />
      </g>
    </svg>
  );
};

export default Scale;
